import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";

const DESKTOP = 1280; // matches Tailwind's xl breakpoint

const Layout = () => {
  // Open by default on desktop, closed on smaller screens where the sidebar
  // sits over the content rather than beside it.
  const [sidebarOpen, setSidebarOpen] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= DESKTOP
  );

  // Crossing the breakpoint should land in that layout's sensible default,
  // otherwise a drawer opened on mobile stays stuck open on desktop.
  useEffect(() => {
    const onResize = () => setSidebarOpen(window.innerWidth >= DESKTOP);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <div className="min-h-screen bg-bgray-100 dark:bg-darkblack-500">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Backdrop for the overlay drawer. Desktop keeps the sidebar docked,
          so it never needs one. */}
      {sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 z-30 bg-black bg-opacity-40 xl:hidden"
          aria-hidden="true"
        />
      )}

      <div
        className={
          "flex min-h-screen flex-col transition-all duration-300 " +
          (sidebarOpen ? "xl:ml-[280px]" : "ml-0")
        }
      >
        <Navbar
          sidebarOpen={sidebarOpen}
          onMenuClick={() => setSidebarOpen((prev) => !prev)}
        />

        <main className="flex-1 px-4 pb-10 pt-6 sm:px-6 xl:px-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
